import { api } from './http';
import type { Dashboard } from './types';

export const dashboard = {
  get: (signal?: AbortSignal) => api.get<Dashboard>('/dashboard', signal),
};
